import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { ShelfLabelRepository } from './repositories/shelf-label.repository';
import { ShelfLabelUpdateRepository } from './repositories/shelf-label-update.repository';
import { ShelfLabelPrintRepository } from './repositories/shelf-label-print.repository';
import { ShelfLabelQueryStateService } from './services/shelf-label-query-state.service';
import { ShelfLabelService } from './services/shelf-label.service';
import { ShelfLabelPrintService } from './services/shelf-label-print.service';
import { SOFTLINE_PERMISSION_UPDATED_ARTICLE_LABEL_PRINT } from './updated-article-label-print.permissions';

export const updatedArticleLabelPrintRoutes: Routes = [
  {
    path: 'updated-article-label-print',
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    canActivateChild: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_UPDATED_ARTICLE_LABEL_PRINT },
    providers: [
      ShelfLabelRepository,
      ShelfLabelUpdateRepository,
      ShelfLabelPrintRepository,
      ShelfLabelQueryStateService,
      ShelfLabelService,
      ShelfLabelPrintService,
    ],
    loadComponent: () =>
      import('./pages/article-label-list/article-label-list.component').then(
        (o) => o.ArticleLabelListComponent
      ),
  },
];
